import { Checkbox } from "@/components/ui/checkbox";
import { useTranslation } from "react-i18next";

/** Tennis Log product eligibility rule: accounts are for people aged 16+. */
export const MIN_ACCOUNT_AGE = 16;

/**
 * Shown on EVERY new-account creation path (email sign-up, first-time Google
 * registration, guest-to-account conversion). Never shown when an established
 * account simply signs in again.
 */
export default function AgeEligibilityCheck({
  checked,
  onChange,
  id = "age-16",
}: {
  checked: boolean;
  onChange: (v: boolean) => void;
  id?: string;
}) {
  const { t } = useTranslation();
  return (
    <label htmlFor={id} className="flex items-start gap-2 text-xs text-muted-foreground cursor-pointer">
      <Checkbox
        id={id}
        checked={checked}
        onCheckedChange={(v) => onChange(v === true)}
        className="mt-0.5"
      />
      <span>
        {t("auth.age16", {
          defaultValue: "I confirm I am at least 16 years old. Tennis Log accounts are for people aged 16 and over.",
        })}
      </span>
    </label>
  );
}
